// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2s6X9","box":"WorkspacesBox_box__1xaWb","node":"WorkspacesBox_node__3e3Zr"};